export default __webpack_public_path__ + "static/media/TransportationTrains_04.0cdeabe7.png";